export const MOSCOW = '34';
export const VOLGOGRAD = '716';
export const VOLZHSKY = '6349';
export const SAMARA = '507';
export const SARATOV = '3439';
export const YAROSLAVL = '3372';
export const NOVOSIBIRSK = '508';
export const IRKUTSK = '5342';
export const KHABAROVSK = '4124';
export const ROSTOV_NA_DONU = '504';
export const ST_PETERSBURG = '506';
export const NOGINSK = '6255';
export const NARO_FOMINSK = '8492';
export const KLIN = '8232';
export const KRASNODAR = '505';
export const IVANOVO = '7278';
export const KAZAN = '1448';
export const N_NOVGOROD = '6466';
export const KEMEROVO = '2393';
export const KURSK = '6062';
export const KRASNOYARSK = '539';
export const UFA = '511';
export const CHEREPOVETS = '6516';
export const TULA = '3258';
export const EKATERINBURG = '715';
export const TOLYATTI = '3402';
export const SARANSK = '6395';
export const PSKOV = '7874';
export const CHELYABINSK = '2149';
export const NABEREZHNYE_CHELNY = '2949';
export const PERM = '5057';
export const NOVOROSSIYSK = '7073';
export const BARNAUL = '2397';
export const VLADIVOSTOK = '7138';
export const KALININGRAD = '6048';
export const KALUGA = '6607';
export const KIROV = '3429';
export const KOSTROMA = '3428';
export const NOVOKUZNETSK = '2389';
export const OMSK = '509';
export const ORENBURG = '4794';
export const PENZA = '3257';
export const PETROZAVODSK = '5343';
export const RYAZAN = '1447';
export const STAVROPOL = '3752';
export const SURGUT = '8157';
export const TVER = '1437';
export const TYUMEN = '1443';
export const ULYANOVSK = '3399';
export const VORONEZH = '510';
export const ARKHANGELSK = '6063';
export const VLADIKAVKAZ = '7011';
export const IZHEVSK = '6609';
export const SMOLENSK = '8332';
export const LIPETSK = '7290';
export const BELGOROD = '6725';
export const KAZAKHSTAN = '40';
